import { dateFormatter } from '@/utils/formatters/date';
import { formatToTitleCase } from '@/utils/formatters/format-to-title-case';

export function formatRelativeDay(isoDate: string, today: Date = new Date()): string {
  const target = dateFormatter(isoDate, 'YYYY-MM-DD');
  const todayStr = dateFormatter(today, 'YYYY-MM-DD');
  const tomorrow = new Date(today);
  tomorrow.setDate(tomorrow.getDate() + 1);
  const tomorrowStr = dateFormatter(tomorrow, 'YYYY-MM-DD');

  const dayMonth = dateFormatter(isoDate, 'DD/MM');

  if (target === todayStr) {
    return `Hoje, ${dayMonth}`;
  }

  if (target === tomorrowStr) {
    return `Amanhã, ${dayMonth}`;
  }

  const weekdayShort = formatToTitleCase(dateFormatter(isoDate, 'weekday') ?? '').replace(/\.$/, '');
  return `${weekdayShort}, ${dayMonth}`;
}
